import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

import type { FormattedData } from './types';

import TokenSelectButton from './TokenSelectButton';
import TokenSelectMenu from './TokenSelectMenu';
import useTokenSelect from './useTokenSelect';

interface Props {
  data: FormattedData;
  isLoading: boolean;
}

const TokenSelectMobile = ({ data, isLoading }: Props) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const result = useTokenSelect(data);

  const bg = useColorModeValue('#FFFFFF', '#111111');
  const titleColor = useColorModeValue('#000000', '#FFFFFF');
  const handleColor = useColorModeValue('#CCCCCC', '#3F3F3F');

  return (
    <>
      <TokenSelectButton isOpen={ isOpen } onClick={ onToggle } data={ result.data } isLoading={ isLoading }/>
      <Drawer isOpen={ isOpen } onClose={ onClose } placement="bottom">
        <DrawerOverlay/>
        <DrawerContent
          bg={ bg }
          borderTopRadius="16px"
          minH="50vh"
          maxH="60vh"
          containerProps={{ zIndex: 1400 }}
        >
          { /* Drag handle */ }
          <Box display="flex" justifyContent="center" pt="12px" pb="4px">
            <Box w="40px" h="4px" borderRadius="2px" bg={ handleColor }/>
          </Box>

          { /* Title */ }
          <Box px="16px" py="12px">
            <Text
              fontSize="16px"
              fontWeight={ 500 }
              fontFamily="'Space Grotesk', sans-serif"
              color={ titleColor }
            >
              Tokens
            </Text>
          </Box>

          <DrawerBody px="16px" pb="48px" overflowY="auto">
            <TokenSelectMenu { ...result }/>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default React.memo(TokenSelectMobile);
